import { render, staticRenderFns } from "./CreateModal.vue?vue&type=template&id=3975a993&scoped=true&lang=pug&"
import script from "./CreateModal.vue?vue&type=script&lang=js&"
export * from "./CreateModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateModal.vue?vue&type=style&index=0&id=3975a993&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3975a993",
  null
  
)

export default component.exports